import CropInsertionSelector from "./CropInsertionSelector";
import PanelPreview from "./PanelPreview";
import usePresentSelector from './usePresentSelector';
import { useMemo } from 'react';
import { createStore } from 'redux';
import NoFigureSelectedScene from './NoFigureSelectedScene';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRef } from 'react';
import FigureEditorContainer from './FigureEditorContainer';
import CanvasFigure from './CanvasFigure';
import G from './Getters';
import CropDragProvider from './CropDragProvider';
import SelectedItemProvider from './SelectedItemProvider';
import FigureInteractionProvider from './FigureInteractionProvider';
import TemporaryCellValueProvider from './TemporaryCellValueProvider';



export default function FigureEditingScene({
  setSvg, 
  svg, 
  setMode, 
  showSearchBar, 
  selectedFigurePanelContext,
  setSelectedFigurePanelContext
}){

  const cellValueInputRef = useRef();

  let figurePanelId = selectedFigurePanelContext.figurePanelId; 

  let figurePanelType = useSelector(state => G.getFigurePanelType(state,figurePanelId));

  let isLoggedIn = useSelector(state => G.isLoggedIn(state));


  let selectedFigurePanelRootName = useSelector(state => !figurePanelId ? undefined : G.getFilesystemName(state, { _id:G.getAbsoluteFsPath(state,{_id:figurePanelId})[0]}));


  const [currentLoginStatus,setCurrentLoginStatus] = useState(isLoggedIn);

  useEffect(() => {

    if( isLoggedIn !== currentLoginStatus ){
      setSelectedFigurePanelContext(null);
      setCurrentLoginStatus(isLoggedIn);
    }

  },[isLoggedIn,figurePanelId,setSelectedFigurePanelContext,currentLoginStatus])



  const [cropIdsSelectedForInsertion,_setCropIdsSelectedForInsertion] = useState([]);
  function setCropIdsSelectedForInsertion(value){


    if( value?.length === 0 && cropIdsSelectedForInsertion?.length === 0 ){
      return;
    }
    _setCropIdsSelectedForInsertion(value||[]);
  }

  if( !figurePanelId ){
    return <NoFigureSelectedScene {...{setSelectedFigurePanelContext}} />
  }


  let cropInsertionSelector = (
    figurePanelType !== "microscopy" && showSearchBar !== false && !selectedFigurePanelRootName.includes("Templates") && <CropInsertionSelector {...{ cropIdsSelectedForInsertion, setCropIdsSelectedForInsertion, setMode }}/>)

    return (

      <CropDragProvider figurePanelId={figurePanelId}>

        <div 
          style={{
            flexGrow:1, 
            minWidth:0,
          }} id="figure-scene-container" 
          class="sg-row full-height full-width">

          {true && cropInsertionSelector} 

          <div class="thin-vertical-line"></div>

          {selectedFigurePanelRootName?.includes("Templates") && <div style={{width:15}}>
            {""}
          </div>}


          <TemporaryCellValueProvider key={figurePanelId}>
            <SelectedItemProvider key={figurePanelId} cellValueInputRef={cellValueInputRef} figurePanelId={figurePanelId}>
              <FigureInteractionProvider figurePanelId={figurePanelId}>
                <FigureEditorContainer 
                  figurePanelType={figurePanelType}
                  setSvg={setSvg}
                  svg={svg}
                  figurePanelId={figurePanelId}
                  cellValueInputRef={cellValueInputRef}
                />
              </FigureInteractionProvider>
            </SelectedItemProvider>
          </TemporaryCellValueProvider>

          {false && <CanvasFigure {...{figurePanelId}}/>}

        </div>
      </CropDragProvider>
    )

}
